import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '../services';

const ANONYMOUS_ENDPOINTS = [/\/api\/auth$/];

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const token = authService.token;

  if (!token || req.url.includes('assets/') || ANONYMOUS_ENDPOINTS.some((pattern) => pattern.test(req.url))) {
    return next(req);
  }

  const authReq = req.clone({
    setHeaders: {
      Authorization: `Bearer ${token}`,
    },
  });
  return next(authReq);
};
